'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (operation) {

    return (0, _extend2['default'])(operation, {

        // is multipart form data
        form: true,

        // cache buster
        query: _qs2['default'].stringify((0, _extend2['default'])({ c: Date.now() }, operation.query || {}), { arrayFormat: 'brackets' }),

        // multipart form data
        data: operation.data && _typeof(operation.data) === 'object' ? _qs2['default'].stringify((0, _extend2['default'])({}, operation.data, { csrf_token: getCSRFToken(operation.data || {}) }), { arrayFormat: 'brackets' }) : operation.data,

        // must return an object - for now - do not return anything from API
        transform: operation.transform || function (ret) {
            return ret ? ret[0] || ret : void 0;
        },
        headers: {
            'accept': 'application/json, text/javascript, */*'
        }
    });
};

function getCSRFToken(data) {

    // Grab from model first...
    if (data && data.csrf_token) {
        return data.csrf_token;
    }

    // And fall back to global if absernt
    var csrfTag = Array.prototype.filter.call(document.head.childNodes, function (tag) {
        return tag.nodeName === 'META' && tag.getAttribute('name') === 'csrf-token';
    }).pop();

    if (csrfTag) return csrfTag.getAttribute('content');
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/map-http-operation.js
 ** module id = 589
 ** module chunks = 0
 **/